<ng-container *ngIf="display$ | async as display">
  <section [class.open]="display === 'open'" (click)="close()">
    <div (click)="$event.stopPropagation()">
      <h1>Do you really want to cancel?</h1>
      <p>Action is irreversible.</p>
      <hr>
      <div class="actions">
        <button class="custom-btn"  (click)="triggerCancelOrder()">Yes</button>
        <div class="other">
          <button class="custom-btn cancel" (click)="close()">No</button>
        </div>
      </div>
    </div>
  </section>
</ng-container>
